import { useTranslation } from "react-i18next";

interface BackButtonProps {
    onClick: () => void;
}

const BackButton = ({ onClick }: BackButtonProps) => {
    const { t } = useTranslation();
    return (
        <button
            onClick={onClick}
            className="text-gray-600 hover:text-gray-800 p-1"
            title={t('forms.back', 'Indietro')}
        >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
        </button>
    );
};

export default BackButton;